// deps
import React, { createContext, useContext, useMemo } from "react";

const HighlightOverlayContext = createContext();

export function HighlightOverlayProvider(props) {
  const { highlighted, setHighlighted, overlayRef, children } = props;

  return (
    <HighlightOverlayContext.Provider
      value={useMemo(
        function () {
          return {
            highlighted,
            setHighlighted,
            overlayRef,
          };
        },
        [highlighted, overlayRef, setHighlighted]
      )}
    >
      {children}
    </HighlightOverlayContext.Provider>
  );
}

export function useHighlightOverlay() {
  return useContext(HighlightOverlayContext);
}
